import { useEffect } from "react";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Trust from "@/components/site/Trust";
import Services from "@/components/site/Services";
import Pricing from "@/components/site/Pricing";
import Areas from "@/components/site/Areas";
import Reviews from "@/components/site/Reviews";
import About from "@/components/site/About";
import Faq from "@/components/site/Faq";
import BookContact from "@/components/site/BookContact";
import Footer from "@/components/site/Footer";
import MobileCallBar from "@/components/site/MobileCallBar";
import FloatingCTA from "@/components/site/FloatingCTA";
import CallQuotePopup from "@/components/site/CallQuotePopup";
import { Toaster } from "@/components/ui/sonner";
import Seo from "@/seo/Seo";
import { organizationSchema, websiteSchema, localBusinessSchema, faqSchema } from "@/seo/schemas";
import { FAQS } from "@/data/siteData";
import { SITE } from "@/data/site";

const HOME_TITLE = "Mobile Car VIN Verification | Orange County & Los Angeles";
const HOME_DESC = `Licensed mobile VIN verification in Orange County & Los Angeles. We come to you and complete DMV REG 31 for eligible vehicles. Call ${SITE.phone}.`;

export default function Site() {
  useEffect(() => {
    document.body.style.background = "#ffffff";
    const hash = window.location.hash?.slice(1);
    if (hash) {
      setTimeout(() => document.getElementById(hash)?.scrollIntoView({ behavior: "smooth" }), 350);
    }
  }, []);

  const schema = [
    organizationSchema(),
    websiteSchema(),
    localBusinessSchema(),
    faqSchema(FAQS),
  ];

  return (
    <div className="bg-white pb-16 lg:pb-0">
      <Seo title={HOME_TITLE} description={HOME_DESC} path="/" schema={schema} />
      <Nav />
      <main>
        <Hero />
        <Trust />
        <Services />
        <Pricing />
        <Areas />
        <Reviews />
        <About />
        <Faq />
        <BookContact />
      </main>
      <Footer />
      <MobileCallBar />
      <FloatingCTA />
      <CallQuotePopup />
      <Toaster position="top-center" theme="light" richColors />
    </div>
  );
}
